import { render, staticRenderFns } from "./NoteEdit.vue?vue&type=template&id=5d5f41b5&scoped=true&"
import script from "./NoteEdit.vue?vue&type=script&lang=js&"
export * from "./NoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f41b5",
  null
  
)

export default component.exports